module.exports = __webpack_public_path__ + "img/bottom4.31bfbc3b.png";